function mergeOptions(defaults, overrides) {
  var key
  var result = {}

  for (key in defaults) {
    if (Object.prototype.hasOwnProperty.call(defaults, key)) {
      result[key] = defaults[key]
    }
  }

  if (!overrides) return result

  for (key in overrides) {
    if (Object.prototype.hasOwnProperty.call(overrides, key)) {
      result[key] = overrides[key]
    }
  }

  return result
}

export function initMediaProtection(options) {
  var defaults = {
    rootSelector: 'body',
    targetSelector: 'img, video',
    disableContextMenu: true,
    disableDragStart: true,
    disableSaveShortcut: false,
    markUndraggable: true,
    disableTouchCallout: true,
  }

  var opts = mergeOptions(defaults, options)
  var root = document.querySelector(opts.rootSelector)
  var selector = opts.targetSelector

  if (!root) return false

  if (opts.markUndraggable) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), function (media) {
      media.setAttribute('draggable', 'false')
    })
  }

  if (opts.disableTouchCallout) {
    Array.prototype.forEach.call(root.querySelectorAll(selector), function (media) {
      media.style.webkitTouchCallout = 'none'
      media.style.webkitUserSelect = 'none'
      media.style.userSelect = 'none'
    })
  }

  function isTarget(event) {
    return !!(event.target && event.target.closest && event.target.closest(selector))
  }

  if (opts.disableContextMenu && !root.__mediaProtectionContextMenuBound) {
    root.addEventListener('contextmenu', function (event) {
      if (isTarget(event)) {
        event.preventDefault()
      }
    })
    root.__mediaProtectionContextMenuBound = true
  }

  if (opts.disableDragStart && !root.__mediaProtectionDragStartBound) {
    root.addEventListener('dragstart', function (event) {
      if (isTarget(event)) {
        event.preventDefault()
      }
    })
    root.__mediaProtectionDragStartBound = true
  }

  if (opts.disableSaveShortcut && !document.__mediaProtectionSaveShortcutBound) {
    document.addEventListener('keydown', function (event) {
      var key = (event.key || '').toLowerCase()
      var isSaveShortcut = (event.ctrlKey || event.metaKey) && key === 's'

      if (isSaveShortcut) {
        event.preventDefault()
      }
    })
    document.__mediaProtectionSaveShortcutBound = true
  }

  return true
}
